import { render } from "./avatar-dropdown.vue?vue&type=template&id=e0d36472&ts=true"
import script from "./avatar-dropdown.vue?vue&type=script&lang=ts"
export * from "./avatar-dropdown.vue?vue&type=script&lang=ts"

import "./avatar-dropdown.vue?vue&type=style&index=0&id=e0d36472&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__